import {Component, OnInit, ElementRef, Renderer2} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {Banner} from '../../../services/api.client';
import {ConfigService} from '../../../services/ConfigService';
import {BannerClient} from '../../../services/api.client';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'shell',
    host: {
        '[class.nav-static]': 'config.state["nav-static"]',
        '[class.app]': 'true',
        id: 'app'
    },
    templateUrl: './ShellComponent.html',
    styleUrls: ['./ShellComponent.scss'],
    standalone: false
})
export class ShellComponent implements OnInit {

  config: any;
  configFn: any;
  sidebarEl: HTMLElement;
  el: ElementRef;
  router: Router;

  banner = new BehaviorSubject<Banner>(null);
  banner$ = this.banner.asObservable();

  constructor(config: ConfigService,
              el: ElementRef,
              router: Router,
              private renderer: Renderer2,
              private bannerClient: BannerClient) {
    this.el = el;
    this.config = config.getConfig();
    this.configFn = config;
    this.router = router;
  }

  ngOnInit(): void {
    this.bannerClient.banner().subscribe(b => {
      this.banner.next(b);
    })

    // Global suppress of default navigation on placeholder `#` anchors
    // (was jQuery's delegated `$(document).on('click', 'a[href="#"]')`).
    this.renderer.listen('document', 'click', (e: Event) => {
      if ((e.target as HTMLElement).closest('a[href="#"]')) {
        e.preventDefault();
      }
    });

    if (localStorage.getItem('nav-static') === 'true') {
      this.config.state['nav-static'] = true;
    }

    this.sidebarEl = this.el.nativeElement.querySelector('[sidebar]');

    this.renderer.listen(this.sidebarEl, 'mouseenter', () => this._sidebarMouseEnter());
    this.renderer.listen(this.sidebarEl, 'mouseleave', () => this._sidebarMouseLeave());

    this.checkNavigationState();

    this.renderer.listen(this.sidebarEl, 'click', () => {
      if (this.el.nativeElement.classList.contains('nav-collapsed')) {
        this.expandNavigation();
      }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.collapseNavIfSmallScreen();
        window.scrollTo(0, 0);
      }
    });

    // Sidebar section collapse is now handled by ngx-bootstrap's `collapse`
    // directive in SidebarComponent (the BS4 jQuery `.collapse` plugin was
    // dropped in BS5). The `.open` li-class is bound there via [class.open];
    // the old `show.bs.collapse`/`hide.bs.collapse` jQuery handlers are removed.
  }

  toggleSidebarListener(state): void {
    if (state === 'static') {
      this.toggleNavigationState();
    } else {
      this.toggleNavigationCollapseState();
    }
    localStorage.setItem('nav-static', this.config.state['nav-static']);
  }

  toggleNavigationState(): void {
    this.config.state['nav-static'] = !this.config.state['nav-static'];
  }

  expandNavigation(): void {
    // this method only makes sense for non-static navigation state
    if (this.isNavigationStatic()
      && (this.configFn.isScreen('lg') || this.configFn.isScreen('xl'))) {
      return;
    }

    this.el.nativeElement.classList.remove('nav-collapsed');
    // (Section submenu state is owned by SidebarComponent's ngx-bootstrap collapse;
    // the old jQuery `.collapse('show')` mini-sidebar re-open was dropped with BS5.)
  }

  collapseNavigation(): void {
    // this method only makes sense for non-static navigation state
    if (this.isNavigationStatic()
      && (this.configFn.isScreen('lg') || this.configFn.isScreen('xl'))) {
      return;
    }

    this.el.nativeElement.classList.add('nav-collapsed');
    // (Section submenu state is owned by SidebarComponent's ngx-bootstrap collapse;
    // the old jQuery `.collapse('hide')` was dropped with BS5.)
  }

  /**
   * Check and set navigation collapse according to screen size and navigation state
   */
  checkNavigationState(): void {
    if (this.isNavigationStatic()) {
      if (this.configFn.isScreen('sm')
        || this.configFn.isScreen('xs') || this.configFn.isScreen('md')) {
        this.collapseNavigation();
      }
    } else {
      if (this.configFn.isScreen('lg') || this.configFn.isScreen('xl')) {
        setTimeout(() => {
          this.collapseNavigation();
        }, this.config.settings.navCollapseTimeout);
      } else {
        this.collapseNavigation();
      }
    }
  }

  isNavigationStatic(): boolean {
    return this.config.state['nav-static'] === true;
  }

  toggleNavigationCollapseState(): void {
    if (this.el.nativeElement.classList.contains('nav-collapsed')) {
      this.expandNavigation();
    } else {
      this.collapseNavigation();
    }
  }

  _sidebarMouseEnter(): void {
    if (this.configFn.isScreen('lg') || this.configFn.isScreen('xl')) {
      this.expandNavigation();
    }
  }

  _sidebarMouseLeave(): void {
    if (this.configFn.isScreen('lg') || this.configFn.isScreen('xl')) {
      this.collapseNavigation();
    }
  }

  collapseNavIfSmallScreen(): void {
    if (this.configFn.isScreen('xs')
      || this.configFn.isScreen('sm') || this.configFn.isScreen('md')) {
      this.collapseNavigation();
    }
  }

}
